import VueRouter from 'vue-router';

import store from '@/store';

import routes from './routes';

export const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from) {
    if (to.path === from.path) return {};
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const TITLE_PREFIX = 'СДО';
  const DEFAULT_TITLE = 'Система дистанционного обучения';
  const isAuthenticated = store.getters['auth/isAuthenticated'];
  const secondStepRequired = store.getters['auth/secondStepRequired'];
  const { authorize, publicOnly, canPublic } = to.meta;
  if (to.meta.title) {
    document.title = `${TITLE_PREFIX} | ${to.meta.title}`;
  } else document.title = DEFAULT_TITLE;

  if (!isAuthenticated && to.name !== 'AuthorizeSecond' && secondStepRequired) {
    return next({ name: 'AuthorizeSecond', query: { redirect: to.path } });
  }

  if (publicOnly) {
    if (isAuthenticated) {
      return next({ name: 'Desktop' });
    }
    return next();
  }

  if (authorize) {
    if (isAuthenticated || canPublic) {
      if (!authorize.length) {
        return next();
      }

      return next();
    }
    return next({ name: 'SignIn' });
  }
  return next();
});

export default router;
